import apiSRE from '@/api/sre';
import apiOption from '@/api/option';

const defaultState = () => ({
	listSRE: [],
	detailSRE: {},
  SREforApprove: [],
	listProduct: [],
	srePagination: '',
	OptionPaymentMethod: [],
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: '',
});

const state = defaultState();

const getters = {
};

const mutations = {
	setSRE(state, data) {
		state.listSRE = data.data
		state.srePagination = data.pagination;
	},
	setDetailSRE(state, data) {
		state.detailSRE = data
	},
	setSREforApprove(state, data) {
		state.SREforApprove = data
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.selected = false
			el.quantity = '1'
			el.serial = []
			return el
		});
	},
	setPaymentMethod(state, data) {
		state.OptionPaymentMethod = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alertMultiple = []
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSRE(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getSRE({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSRE.getSRE(params).then(({ data: { data } }) => {
				commit('setSRE', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setSRE', { data: [], pagination: {} });
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSREAll({ dispatch, commit }, params) {
		apiSRE.getSREAll(params).then(({ data: { data } }) => {
			commit('setSRE', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setSRE', { data: [], pagination: {} });
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	getDetailSRE({ commit, dispatch }, params) {
		apiSRE.getDetailSRE(params).then(({ data: { data } }) => {
			commit('setDetailSRE', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSRE', {});
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getOptionProductSRE().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getOptionPaymentMethod({ commit }) {
		apiOption.getOptionPaymentMethod().then(({ data: { data } }) => {
			commit('setPaymentMethod', data.results);
		}).catch(() => {
			commit('setPaymentMethod', []);
		});
	},
	async createSRE({ commit, dispatch }, params) {
		await apiSRE.createSRE(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async approveSRE({ commit, dispatch }, params) {
		await apiSRE.approveSRE(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getOptionWarehouse({ dispatch }) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouseAll().then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionSREforApprove({ commit, dispatch }) {
		return new Promise(() => {
			apiOption.getOptionSREforApprove().then(({ data: { data } }) => {
				commit('setSREforApprove', data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	async exportSRE({ dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSRE.exportSRE(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSREAll({ dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSRE.exportSREAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
		await dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
